import { Injectable } from '@angular/core';
import { MantenimientoCultivosFilters } from '../models/mantenimiento-cultivos-filters.component';
import { ProductoresFilters } from '../models/productores-filters.model';

@Injectable()
export class CultivosContextService {
    mantenimientoCultivosFilters: MantenimientoCultivosFilters;
    public productoresFilters: ProductoresFilters;
}